import { useEffect } from 'react';
import { coreFromSettings } from '../theme/config';
import { wearTheme } from '../theme/root';
// Dresses the page in a community's colors while mounted with settings, and takes them off on cleanup.
export const useCommunityTheme = (settings) => {
    useEffect(() => settings === null ? undefined : wearTheme(coreFromSettings(settings)), [settings]);
};
export default useCommunityTheme;
